const model = {
    name: 'RelatedQuestions',
    properties: {
        limit: {},
        offset: {}, // TODO: integer <int64> [ 1 .. 100 ]
    },
};
export default model;
